export default "__VITE_ASSET__YOwAQAOH__"